module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white-background-wrap"
  }, [_c('div', {
    staticClass: "about"
  }, [_c('h2', {
    staticClass: "section-header"
  }, [_vm._v("About Me")]), _vm._v(" "), _c('p', [_vm._v("Hey guys! I'm Lowco. I stream full-time on Twitch with a focus on community, good vibes, and silly fails. I've been streaming since May 2014 with a primary focus on gaming-related content. Check out my website to learn more about what I do!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75ce67cc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/About.vue
// module id = 1178
// module chunks = 2